import React, { useEffect } from "react";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ButtonGroup,
  Row,
  LabelText,
  Column,
  Input,
  ConfirmButton,
  CancelButton,
  Textarea,
  Buttons,
  Button,
  PromptRow,
} from "./CustomizeEditImageModal.styles";
import Modal from "../utils/Modal/Modal";

const CustomizeEditImageModal = ({
  isOpen,
  onClose,
  customPrompt,
  setCustomPrompt,
  seedNumber,
  setSeedNumber,
  isEditImageModel,
  collectionSeed,
  resetSeed,
}) => {
  const [seedMode, setSeedMode] = React.useState(() => {
    return localStorage.getItem("seedMode") || "random";
  });

  const generateRandomSeed = () => {
    return Math.floor(Math.random() * 10000000) + 1;
  };

  useEffect(() => {
    const savedSeedMode = localStorage.getItem("seedMode");
    const savedCustomSeed = localStorage.getItem("customSeed");
    if (savedSeedMode) {
      setSeedMode(savedSeedMode);

      if (savedSeedMode === "random") {
        setSeedNumber(generateRandomSeed());
        return;
      }

      if (savedSeedMode === "default") {
        setSeedNumber(collectionSeed);
        return;
      }

      if (savedSeedMode === "custom") {
        if (savedCustomSeed) {
          setSeedNumber(Number(savedCustomSeed));
        } else {
          // Fallback for custom mode without saved seed
          const newSeed = collectionSeed ?? generateRandomSeed();
          setSeedNumber(newSeed);
          localStorage.setItem("customSeed", newSeed);
        }
        return;
      }
    }

    // Fallback if no saved mode exists
    if (collectionSeed) {
      setSeedNumber(collectionSeed);
    } else {
      setSeedNumber(generateRandomSeed());
    }
  }, [setSeedNumber, collectionSeed, seedMode, resetSeed]);

  const handleConfirm = () => {
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>Settings</ModalTitle>

            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>

          {!isEditImageModel && (
            <Column>
              <LabelText>Custom Prompt</LabelText>

              <Textarea
                type="text"
                placeholder="Enter your custom prompt here"
                value={customPrompt}
                onChange={(e) => {
                  setCustomPrompt(e.target.value);
                }}
              />
            </Column>
          )}

          <Column>
            <LabelText>Seed</LabelText>
            <PromptRow>
              <Buttons>
                <Button
                  $active={seedMode === "random"}
                  onClick={() => {
                    setSeedMode("random");
                    localStorage.setItem("seedMode", "random");
                    setSeedNumber(generateRandomSeed());
                  }}
                >
                  Random
                </Button>
                <Button
                  $active={seedMode === "default"}
                  onClick={() => {
                    setSeedMode("default");
                    localStorage.setItem("seedMode", "default");
                    setSeedNumber(collectionSeed);
                  }}
                >
                  Default
                </Button>
                <Button
                  $active={seedMode === "custom"}
                  onClick={() => {
                    setSeedMode("custom");
                    localStorage.setItem("seedMode", "custom");
                  }}
                >
                  Custom
                </Button>
              </Buttons>
            </PromptRow>
            {seedMode === "custom" && (
              <Input
                disabled={seedMode === "random"}
                type="number"
                placeholder="Enter your seed here..."
                value={seedNumber}
                min={1}
                max={9007199254740991}
                onChange={(e) => {
                  const value = parseInt(e.target.value);
                  if (value >= 0 && value <= 9007199254740991) {
                    setSeedNumber(value > 0 ? value : 1);
                    if (seedMode === "custom") {
                      localStorage.setItem("customSeed", value > 0 ? value : 1);
                    }
                  }
                }}
              />
            )}
          </Column>

          <ButtonGroup>
            <CancelButton onClick={handleCancel}>Cancel</CancelButton>
            <ConfirmButton onClick={handleConfirm} $type={"primary"}>
              Confirm
            </ConfirmButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default CustomizeEditImageModal;
